import { createAction, props } from '@ngrx/store';
import { IPainters } from '@interfaces';

export const loadPainters = createAction('[Cart] Load Painters');
export const loadPaintersSuccess = createAction('[Cart] Load Painters Success', props<{ painters: IPainters[] }>());
export const addPainters = createAction('[Cart] Add Painters', props<{ painters: IPainters[] }>());
export const removePainter = createAction('[Cart] Remove Painter', props<{ painterId: number }>());
